import {
  Button,
  ButtonGroup,
  createStyles,
  Input,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';

interface PlusMinusFieldProps extends WithStyles<typeof styles> {
  initial?: number;
  disabled?: boolean;
  suffix?: string;
  onChange?: (value: number) => void;
}

const PlusMinusField: FC<PlusMinusFieldProps> = (props) => {
  const { initial, classes, disabled, suffix, onChange } = props;
  const [value, setValue] = useState<number>(initial || 0);
  const [focused, setFocused] = useState<boolean>(false);

  const onChangeInput = (e: ChangeEvent) => {
    setValue(parseInt((e.target as HTMLInputElement).value));
  };

  useEffect(() => {
    onChange && onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <ButtonGroup
      variant="contained"
      color="primary"
      aria-label="contained primary button group"
    >
      <Button
        disabled={disabled}
        onClick={() => {
          setValue(value + 1);
        }}
      >
        <Add />
      </Button>
      <Input
        disabled={disabled}
        value={value + (!focused ? suffix || '' : '')}
        onChange={onChangeInput}
        className={classes?.field}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <Button
        disabled={disabled}
        onClick={() => {
          value && setValue(value - 1);
        }}
      >
        <Remove />
      </Button>
    </ButtonGroup>
  );
};

const styles = () =>
  createStyles({
    field: {
      maxWidth: '80px',
      '& input': {
        textAlign: 'center',
      },
    },
  });

export default withStyles(styles)(PlusMinusField);
